import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetCompanyAutocompleteParams } from "apis/data-contracts";
import useDebouncedState from "features/common/hooks/useDebouncedState";

const useCompaniesAutoCompleteQuery = (
  options: Partial<GetCompanyAutocompleteParams>,
) => {
  const option = useDebouncedState(options, 500);

  return useQuery({
    queryKey: api.tag.getCompanyAutocompleteKey(
      option as GetCompanyAutocompleteParams,
    ),
    queryFn: () =>
      api.tag.getCompanyAutocomplete(option as GetCompanyAutocompleteParams),
    enabled:
      option?.searchTerm !== undefined && option?.searchTerm.trim() !== "",
    placeholderData: (pre) => pre,
  });
};

export default useCompaniesAutoCompleteQuery;
